import React, {useState, useEffect} from 'react'
// import './Orders.scss';
import { connect } from 'react-redux';
// import { Tabs } from 'antd';
// import MenuVertical from '../../Organisms/MenuVertical/MenuVertical';
// import OrderCardBuyer from '../../Molecules/OrderCardBuyer/OrderCardBuyer';
// import OrderCardReserved from '../../Molecules/OrderCardReserved/OrderCardReserved
import OrderCardDelivered from '../../Molecules/OrderCardDelivered/OrderCardDelivered';
// import EmptyCart from '../../Molecules/EmptyCart/EmptyCart';
import logoHistorial from '../../../assets/P1-perfil-historial-no-historial-compras-imagen.png';
import Loader from '../../Atoms/Loader/Loader';
// import { ReloadOutlined } from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import OrderCardDescriptionHistoryPurchase from '../../Molecules/OrderCardDescription/OrderCardDescriptionHistoryPurchase';
const defaultLimit = 10;

const MyOrdersHistory = (props) => {
    const { t } = useTranslation();
    // const [allOrderSeller, setAllOrderSeller] = useState([]) //Para guardar lo que me han comprado
    const [reload, setReload] = useState(false)
    const [reReload, setReReload] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [allOrder, setAllOrder] = useState([]) //Para guardar las ordenes
    // const [allOrder2, setAllOrder2] = useState([]) //Para guardar las ordenes historial
    const [offset, setOffset] = useState(0) //offset
    const [ordersEmpty, setOrdersEmpty] = useState(false) //offset

    // Valida que exista una orden en el historial
    const validOrder = (array, message) => {
      let result = false
      array &&
      array.forEach(o=> {
        if(o.status === message && !o.deliveryConfirmed) {
          result = true
        }
      })
      return result
    }
    // Valida que una orden tenga el deliveryConfirm
    // const validdeliveryConfirm = (array, message) => {
    //   let result = false
    //   array &&
    //   array.forEach(o=> {
    //     if(o.status === message && o.deliveryConfirmed) {
    //       result = true
    //     }
    //   })
    //   return result
    // }
    // let requestedOrders = validOrder(allOrder, "Reservado")
    // let ordersInWait = validOrder(allOrder, "En espera")
    let reservedOrders = validOrder(allOrder, "Entregado")
    // let orderConfirmDelivery = validdeliveryConfirm(allOrder, 'Entregado')
    // let valid2 
    
    // if(ordersInWait === true || requestedOrders === true || orderConfirmDelivery) valid2 = true

    useEffect(() => {
      // document.body.scrollIntoView({block:'start'})
      setReload(false)
      setReReload(false)
      let orders = []
      // fetch(`${process.env.REACT_APP_API_URL}/orders-by-buyer/${props.userInfo.person.userId}`)
      // .then(resp => resp.json())
      // .then(resp => {
      //   console.log(resp)
      //   resp.findOrders.map(order => (
      //     orders.push(order)
      //   ))
      //   setAllOrder(orders)
      //   setIsLoading(false);
      // })

      // Nuevo endpoint
      fetch(`${process.env.REACT_APP_API_URL}/buyer-order-history/${props.userInfo.person.userId}/${defaultLimit}/${offset}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(resp => resp.json())
      .then(resp => {
        if(resp.findOrderHistory.count < 1) {
          setOrdersEmpty(true)
        }else {
          setOrdersEmpty(false)
        }
        // console.log(resp)
        resp.findOrderHistory.rows.map(order => (
          orders.push(order)
        ))
        setAllOrder(orders)
        setIsLoading(false);
      })
      // const reloadPage = setInterval(() => {
      //   setReload(true)
      // }, 1000)
      // la función se frena al desmontar el componente
      // return () => {
      //   clearInterval(reloadPage)
      // }
    }, [props.userInfo.person.userId, props.userInfo.userRoleId, reload, reReload])

  return (
      <>
      <div className="profile-container container-orders">
      <div className="wrapped-profile-container">
        {/* {
          reload 
          ? <ReloadOutlined spin className="icon-load" />
          : <ReloadOutlined className="icon-load" onClick={() => setReload(true)}/>
        } */}
        {isLoading? <Loader /> :
          <div className='box container-orders-reserved'>
            {reservedOrders && <h2 className='center-text title-form'>{t("order-history", {a: ' '})}</h2>}
                {
                  allOrder.map(orderSeller => (
                    /* orderSeller.status === 'Entregado' && !orderSeller.deliveryConfirmed && //Me muestra solo las ordenes entragadas y ya calificadas. */
                    // <OrderCardDelivered key={orderSeller.id}
                    //   order={orderSeller} 
                    //   // setReload={setReload} 
                    // />
                    
                     orderSeller.status === 'Entregado' && !orderSeller.deliveryConfirmed && //Me muestra solo las ordenes entragadas y ya calificadas. 
                    <OrderCardDescriptionHistoryPurchase key={orderSeller.id}
                      order={orderSeller.buyerOrderItemHistory} 
                      storeName={orderSeller.sellerName}
                      originalOrderId={orderSeller.originalOrderId}
                      totalPrice={orderSeller.totalPrice}
                      // setReload={setReload} 
                    />
                  ))
                }
                {
                  !reservedOrders &&
                  <div className="main-empty">
                    <h2>{t("empty-history", {a: ' '})}</h2>
                    <img src={logoHistorial} alt={t("empty-history", {a: ' '})}/>
                  </div>
                }
          </div>
          }
      </div>
      </div>
      </>
  )
}

const mapStateToProps = (state) => ({
  userInfo: state.userReducer.userInfo
})
export default connect(mapStateToProps)(MyOrdersHistory)


